import { QuestionsViewModel, UserQuestionViewModel } from 'models/hotel';
import { mapUserQuestion } from 'stores/adapters/bex-api/questions-answers/user-question-answer-adapter';
import { FindAnswersSearch } from '__generated__/api';
import ProductQuestions = FindAnswersSearch.ProductQuestions;

export const mapQuestions = (currentStore: QuestionsViewModel, response: ProductQuestions, totalRequested?: number): QuestionsViewModel => {
  const userQuestions: UserQuestionViewModel[] = response.questions.map(mapUserQuestion);

  currentStore.count = response.totalCount.raw;

  if (!currentStore.userQuestions) {
    currentStore.userQuestions = [];
  }

  currentStore.userQuestions.push(...userQuestions);
  currentStore.totalQuestionAnswersRequested = totalRequested;

  return currentStore;
};
